import { css } from 'styled-components'
import { hiDPI } from 'polished'

export const antiAlias = (scale: number, color: string) => {
  return css`
    box-shadow: 0 0 ${scale}px ${scale}px ${color};
    ${hiDPI(1.3)} {
      box-shadow: none;
    }
  `
}



// WEBPACK FOOTER //
// ./src/styles/antiAlias.ts